module.exports = __webpack_public_path__ + "img/calendar.f9c3e190.svg";